import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import EnumRecordTypes from "../../enums/enumRecordTypes";
import EnumRecordStates from "../../enums/enumRecordStates";
import { JsonSampleData } from "../../data/sampledata";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
  GET_RECORDS,
  GET_GA_RECORDS,
  GET_DROPDOWN_SEARCH_LIST,
  GET_CHILD_RECORDS,
} from "../actions";
import axios from "../../axios/centralApiAxios";
import getSubdomain from "../../hooks/url/getSubdomain";

import Params from "./../../components/uiControls/paramconstant";

import {
  getRecordsSuccess,
  getGARecordsSuccess,
  getRecordsError,
  getGARecordsError,
  getSearchListSuccess,
  getChildRecordsSuccess,
  getChildRecordsError,
} from "./actions";
import getActivityListing from "./activityRecordListing";
// import EnumOrderStates from "../../enums/enumOrderStates";

export function* watchGetRecords() {
  yield takeEvery(GET_RECORDS, getRecordList);
}

export function* watchGetChildRecords() {
  yield takeEvery(GET_CHILD_RECORDS, getChildRecordList);
}

export function* watchGetGARecords() {
  yield takeEvery(GET_GA_RECORDS, getGARecordList);
}

export function* watchGetDropdownSearchList() {
  yield takeEvery(GET_DROPDOWN_SEARCH_LIST, getDropdownSearchList);
}

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};

// this getCurrentPaageRecords will be removed in future iteration, since pagedList will be retrieved from db
// eslint-disable-next-line
const getCurrentPageRecords = (allRecords, pageNumber, pageSize) => {
  let currentPageRecords = [];
  if (Object.keys(allRecords).length > 0) {
    for (const key in allRecords) {
      currentPageRecords.push({
        ...allRecords[key],
        id: allRecords[key].contactId,
      });
    }
  }
  const startIndex = (pageNumber - 1) * pageSize;
  const lastIndex = startIndex + pageSize;
  currentPageRecords = currentPageRecords.slice(
    startIndex,
    currentPageRecords.length >= lastIndex
      ? lastIndex
      : currentPageRecords.length
  );
  return currentPageRecords;
};

const getRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();
  let pageSize = 20;

  const filteredRows = [];
  const search_text =
    payload.selectedFilters &&
      payload.selectedFilters.contactSearchText &&
      payload.selectedFilters.contactSearchText.text
      ? payload.selectedFilters.contactSearchText.text
      : "";
  // eslint-disable-next-line
  const locationText =
    payload.selectedFilters &&
      payload.selectedFilters.locationId &&
      payload.selectedFilters.locationId.text
      ? payload.selectedFilters.locationId.text
      : "";
  const primary_organization_contact_id =
    payload.selectedFilters &&
      payload.selectedFilters.primaryOrganizationId &&
      payload.selectedFilters.primaryOrganizationId.id
      ? payload.selectedFilters.primaryOrganizationId.id
      : "";
  const sort_by =
    payload.selectedFilters &&
      payload.selectedFilters.sortStatus &&
      payload.selectedFilters.sortStatus.sortby
      ? payload.selectedFilters.sortStatus.sortby
      : "";
  const is_sort_order_desc =
    payload.selectedFilters &&
      payload.selectedFilters.sortStatus &&
      payload.selectedFilters.sortStatus.isSortOrderDesc
      ? payload.selectedFilters.sortStatus.isSortOrderDesc
      : "0";

  const typeNodeId =
    payload.selectedFilters &&
      payload.selectedFilters.typeNodeId &&
      payload.selectedFilters.typeNodeId.id
      ? payload.selectedFilters.typeNodeId.id
      : "";

  const formDate = payload.selectedFilters && payload.selectedFilters.formDate && payload.selectedFilters.formDate.text ? payload.selectedFilters.locationId.text : "";
  const toDate = payload.selectedFilters && payload.selectedFilters.toDate && payload.selectedFilters.toDate.text ? payload.selectedFilters.toDate.text : "";

  // const processTypeId =
  //   payload.selectedFilters &&
  //     payload.selectedFilters.processTypeId &&
  //     payload.selectedFilters.processTypeId.id
  //     ? payload.selectedFilters.processTypeId.id
  //     : "";

  let payloadSearchText = payload.searchText ? payload.searchText : "";
  payloadSearchText = payloadSearchText ? payloadSearchText : search_text;
  try {
    const currentRecordType =
      typeof payload.recordType === "string"
        ? getRecordType(payload.recordType)
        : payload.recordType;

    switch (currentRecordType) {
      case EnumRecordTypes.Person:
        const recordContactListReturned = await axios.get(
          `${"Contacts" + "?searchText="
          }${payloadSearchText}&primaryTypeNodeId=${typeNodeId}&primaryOrganizationContactId=${primary_organization_contact_id}&sortBy=${sort_by}&isSortOrderDesc=${is_sort_order_desc}&hasUserAccount=${payload.hasUserAccount ? payload.hasUserAccount : ""
          }&recordtype=${payload.isPersonOnly ? '3010' : ''}` +
          `&pageSize=${pageSize}&pageNumber=${payload.pageNumber}`
          , getActivityHeadersUpdated(payload)
        );
        return {
          recordList: recordContactListReturned.data.items,
          total_item_count: recordContactListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Password:
        let recordPasswordListReturned = []
        recordPasswordListReturned.data = [];
        recordPasswordListReturned.data.items = [];

        let itemPassword1 = [];
        itemPassword1.userName = "demo@minasu.net";
        itemPassword1.contactId = "First2 Last2"
        itemPassword1.message = "Reset password";
        itemPassword1.timeStamp = new Date();

        let itemPassword2 = [];
        itemPassword2.userName = "demo@minasu.net";
        itemPassword2.contactId = "First2 Last2"
        itemPassword2.message = "Change password";
        itemPassword2.timeStamp = new Date();

        recordPasswordListReturned.data.items.push(itemPassword1);
        recordPasswordListReturned.data.items.push(itemPassword2);

        return {
          recordList: recordPasswordListReturned.data.items,
          total_item_count: recordPasswordListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.UserAudit:
        const recordLoginHistoryListReturned = await axios.get(
          `useraudits?search_text=${payloadSearchText}&from_date=${formDate}&to_Date=${toDate}&page_size=${pageSize}&page_number=${payload.pageNumber}`
        );
        return {
          recordList: recordLoginHistoryListReturned.data.items,
          total_item_count: recordLoginHistoryListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Organization:
        const recordOrganizationListReturned = await axios.get(
          `${"Contacts" + "?searchText="
          }${payloadSearchText}&primaryTypeNodeId=${typeNodeId}&primaryOrganizationContactId=${primary_organization_contact_id}&sortBy=${sort_by}&isSortOrderDesc=${is_sort_order_desc}&recordType=3005` +
          `&pageNumber=${payload.pageNumber}`
        );
        return {
          recordList: recordOrganizationListReturned.data.items,
          total_item_count:
            recordOrganizationListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Articles:
        {
          const search_text =
            payload.selectedFilters &&
              payload.selectedFilters.articleSearchText &&
              payload.selectedFilters.articleSearchText.text
              ? payload.selectedFilters.articleSearchText.text
              : "";

          const recordTermListReturned = await axios.get(`posts?record_type=Article&pageNumber=1&search_text=` + search_text);

          return {
            recordList: recordTermListReturned.data,
            total_item_count: recordTermListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        }
      case EnumRecordTypes.Term:
        const term_search_text =
          payload.selectedFilters &&
            payload.selectedFilters.termSearchText &&
            payload.selectedFilters.termSearchText.text
            ? payload.selectedFilters.termSearchText.text
            : "";

        const recordTermListReturned = await axios.get("Terms?trashed=false&search_text=" + term_search_text + "&pageNumber=" + payload.pageNumber, getActivityHeadersUpdated(payload));

        return {
          recordList: recordTermListReturned.data,
          total_item_count: recordTermListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.ContactTypes:
        const recordContactTypeListReturned = await axios.get(
          `${"Nodes" + "?search_text="}${payload.searchText
          }` + `&record_type=${EnumRecordTypes.ContactTypes}` + `&pageNumber=${payload.pageNumber}`
        );

        return {
          recordList: recordContactTypeListReturned.data.items,
          total_item_count: recordContactTypeListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Address:
        const recordlocationReturned = JSON.parse(
          JSON.stringify(JsonSampleData[0])
        );
        receiveDate = new Date().getTime();
        recordlocationReturned.LocationListing.row.forEach((f) => {
          if (
            search_text === "" ? true : f.Address.Text.includes(search_text)
          ) {
            filteredRows.push(f);
          }
        });
        return {
          recordList: filteredRows,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Task:
        const task_search_text =
          payload.selectedFilters &&
            payload.selectedFilters.taskSearchText &&
            payload.selectedFilters.taskSearchText.text
            ? payload.selectedFilters.taskSearchText.text
            : "";
        const task_priorityId =
          payload.selectedFilters &&
            payload.selectedFilters.priorityId &&
            payload.selectedFilters.priorityId.id
            ? payload.selectedFilters.priorityId.id
            : "";
        const primary_organization_id =
          payload.selectedFilters &&
            payload.selectedFilters.primaryOrganizationId &&
            payload.selectedFilters.primaryOrganizationId.id
            ? payload.selectedFilters.primaryOrganizationId.id
            : "";

        const type_node_id_text =
          payload.selectedFilters &&
            payload.selectedFilters.typeNodeId &&
            payload.selectedFilters.typeNodeId.text
            ? payload.selectedFilters.typeNodeId.text
            : "";

        const recordTasksreturned = await axios.get(
          `posts/20710/getlist?searchText=` +
          task_search_text +
          "&priorityId=" +
          task_priorityId +
          "&assignedToContactId=" +
          primary_organization_id +
          "&inCompleteSearchText=" +
          type_node_id_text
        );

        return {
          recordList: recordTasksreturned.data,
          total_item_count: 2,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.TaskList:
        const search_text =
          payload.selectedFilters &&
            payload.selectedFilters.taskListSearchText &&
            payload.selectedFilters.taskListSearchText.text
            ? payload.selectedFilters.taskListSearchText.text
            : "";

        const recordTaskListReturned = await axios.get(
          `posts/201/getlist?searchText=` + search_text
        );

        return {
          recordList: recordTaskListReturned.data,
          total_item_count: 2,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.PROJECTS:
        const project_search_text =
          payload.selectedFilters &&
            payload.selectedFilters.projectSearchText &&
            payload.selectedFilters.projectSearchText.text
            ? payload.selectedFilters.projectSearchText.text
            : "";
        const recordProjectsListReturned = await axios.get(
          `${"Collections?trashed=false&verbType=2&search_text="}${project_search_text}&pageSize=${pageSize}&pageNumber=${payload.pageNumber
          }`
        );

        return {
          recordList: recordProjectsListReturned.data,
          total_item_count: 2,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.SaaS:
        const tenantSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.tenantSearchText &&
            payload.selectedFilters.tenantSearchText.text
            ? payload.selectedFilters.tenantSearchText.text
            : "";
        let tenantName = getSubdomain();
        if (payload.profile.tenants) {
          const tenantObj = JSON.parse(payload.profile.tenants);
          tenantName = tenantObj.TenantRelations[0].TenantName;
        }
        const recordTenantsListReturned = await axios.get(
          "tenants?trashed=false&search_text=" +
          tenantSearchText +
          "&parentTenantName=" +
          tenantName +
          "&pageNumber=" +
          payload.pageNumber,
          getActivityHeadersUpdated(payload)
        );
        return {
          recordList: recordTenantsListReturned.data,
          total_item_count: recordTenantsListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Collection:
        const collectionSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.collectionSearchText &&
            payload.selectedFilters.collectionSearchText.text
            ? payload.selectedFilters.collectionSearchText.text
            : "";

        const recordCollectionListReturned = await axios.get(
          "collections?search_text=" +
          collectionSearchText +
          "&parentCollectionId=" +
          "&verbType=" + (payload.verbType === undefined ? 2 : payload.verbType)
        );

        return {
          recordList: recordCollectionListReturned,
          total_item_count: recordCollectionListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.OrderStatus: {
        let selectOptions = [
          { id: "1", text: "Draft" },
          { id: "2", text: "Open" },
          { id: "3", text: "Processing" },
          { id: "4", text: "Pending" },
          { id: "5", text: "Complete" },
        ];

        return {
          recordList: selectOptions,
          total_item_count: 5,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      }
      case EnumRecordTypes.Orders:
        let recordOrderListReturned = []

        let orderitemSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.orderSearchText &&
            payload.selectedFilters.orderSearchText.text
            ? payload.selectedFilters.orderSearchText.text
            : "";

        let contactSelectionText =
          payload.selectedFilters &&
            payload.selectedFilters.OrderContact &&
            payload.selectedFilters.OrderContact.id
            ? payload.selectedFilters.OrderContact.id
            : "";

        let orderFromDateText =
          payload.selectedFilters &&
            payload.selectedFilters.orderFromDate
            ? payload.selectedFilters.orderFromDate
            : "";

        let orderToDateText =
          payload.selectedFilters &&
            payload.selectedFilters.orderToDate
            ? payload.selectedFilters.orderToDate
            : "";

        console.log(orderFromDateText);
        console.log(orderToDateText);

        let orderStatus =
          payload.selectedFilters &&
            payload.selectedFilters.OrderStatus &&
            payload.selectedFilters.OrderStatus.text
            ? payload.selectedFilters.OrderStatus.text
            : "";

        const re = /^[0-9\b]+$/;

        if (orderitemSearchText === '' || re.test(orderitemSearchText)) {

        }
        else {
          orderitemSearchText = "-1";
        }

        try {
          recordOrderListReturned = await axios.get(
            "orders?trashed=false&order_id=" + orderitemSearchText +
            "&pageNumber=" + payload.pageNumber +
            "&contactId=" + contactSelectionText +
            "&order_from_date=" + orderFromDateText +
            "&order_to_date=" + orderToDateText +
            "&orderStatus=" + orderStatus
            , getActivityHeadersUpdated(payload));
        }
        catch (e) {
        }

        return {
          recordList: recordOrderListReturned,
          total_item_count: recordOrderListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Payments:

        let recordPaymentListReturned = []
        recordPaymentListReturned.data = [];
        recordPaymentListReturned.data.items = [];


        let paymentItemSearchId =
          payload.selectedFilters &&
            payload.selectedFilters.paymentItemSearchId &&
            payload.selectedFilters.paymentItemSearchId.text
            ? payload.selectedFilters.paymentItemSearchId.text
            : "";

        try {
          recordPaymentListReturned = await axios.get("payments?trashed=false&payment_id=" + paymentItemSearchId + "&page_number=" + payload.pageNumber, getActivityHeadersUpdated(payload));
        }
        catch (e) {
        }
        return {
          recordList: recordPaymentListReturned,
          total_item_count: recordPaymentListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Page:
        let recordPageListReturned = []
        recordPageListReturned.data = [];
        recordPageListReturned.data.items = [];

        try {
          recordPageListReturned = await axios.get("content_items?trashed=false&record_type=10505" + "&page_number=" + payload.pageNumber);

        }

        catch (e) {

        }
        return {
          recordList: recordPageListReturned,
          total_item_count: recordPageListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.PaymentMethods:
        let recordPaymentMethodListReturned = []
        recordPaymentMethodListReturned.data = [];
        recordPaymentMethodListReturned.data.items = [];

        let item4 = [];
        item4.paymentmethodid = "4";
        item4.name = "Cash";
        item4.account = "Cash";
        item4.methodType = "Cash";
        item4.accesstype = "Restricted"
        recordPaymentMethodListReturned.data.items.push(item4);
        // eslint-disable-next-line
        let paymentitemSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.paymentitemSearchText &&
            payload.selectedFilters.paymentitemSearchText.text
            ? payload.selectedFilters.paymentitemSearchText.text
            : "";

        return {
          recordList: recordPaymentMethodListReturned,
          total_item_count: recordPaymentMethodListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Accounts:

        let recordAccountListReturned = []
        recordAccountListReturned.data = [];
        recordAccountListReturned.data.items = [];

        let item3 = [];
        item3.account_id = "4";
        item3.account_number = "4185-0520";
        item3.name = "CPA History and Philosophy Section Fireside Chat";
        item3.is_default = true
        recordAccountListReturned.data.items.push(item3);

        let accountitemSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.accountitemSearchText &&
            payload.selectedFilters.accountitemSearchText.text
            ? payload.selectedFilters.accountitemSearchText.text
            : "";

        try {
          recordAccountListReturned = await axios.get("accounts?trashed=false&search_text=" + accountitemSearchText + "&page_number=" + payload.pageNumber);
        }
        catch (e) {
        }


        return {
          recordList: recordAccountListReturned,
          total_item_count: recordAccountListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };

      case EnumRecordTypes.Invoices:

        // const recordInvoiceListReturned = JsonSampleData[0];
        let recordInvoiceListReturned = [];
        receiveDate = new Date().getTime();
        let invoiceSearchText = payload.selectedFilters && payload.selectedFilters["invoiceSearchText"] && payload.selectedFilters["invoiceSearchText"].text ? payload.selectedFilters["invoiceSearchText"].text : "";
        let billingContactId = payload.selectedFilters && payload.selectedFilters["billingContactId"] && payload.selectedFilters["billingContactId"].id > 0 ? payload.selectedFilters["billingContactId"].id.toString() : "";
        let invoiceId = payload.selectedFilters && payload.selectedFilters["invoiceId"] && payload.selectedFilters["invoiceId"].id > 0 ? payload.selectedFilters["invoiceId"].id.toString() : "";
        pageSize = 5
        try {
          recordInvoiceListReturned = await axios.get(`invoices?trashed=false&search_text=${invoiceSearchText}&invoice_id=${invoiceId}&billingContactId=${billingContactId}&pageNumber= ${payload.pageNumber}&pageSize= ${pageSize}`, getActivityHeadersUpdated(payload));

        }
        catch (e) {
        }
        return {
          recordList: recordInvoiceListReturned.data.items,
          total_item_count: recordInvoiceListReturned.data.totalItemCount,//Todo: changed after api call
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.CatalogItems:
        {
          let catalogitemSearchText =
            payload.selectedFilters &&
              payload.selectedFilters.catalogitemSearchText &&
              payload.selectedFilters.catalogitemSearchText.text
              ? payload.selectedFilters.catalogitemSearchText.text
              : "";

          let recordCatalogListReturned = []
          recordCatalogListReturned.data = [];
          recordCatalogListReturned.data.items = [];

          let item1 = [];
          item1.code = "CI1";
          item1.name = "Catalog item 1";
          item1.price = "$90";
          item1.catalogItemId = 4;
          recordCatalogListReturned.data.items.push(item1);

          recordCatalogListReturned = await axios.get("catalog_items?trashed=false&sort_by=1&search_text=" + catalogitemSearchText + "&pageNumber=" + payload.pageNumber, getActivityHeadersUpdated(payload));

          return {
            recordList: recordCatalogListReturned,
            total_item_count: recordCatalogListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        }
      case EnumRecordTypes.Remittances:
        let remittanceSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.remittanceSearchText &&
            payload.selectedFilters.remittanceSearchText.text
            ? payload.selectedFilters.remittanceSearchText.text
            : "";
        // eslint-disable-next-line
        let organization_by =
          payload.selectedFilters &&
            payload.selectedFilters.organization_by &&
            payload.selectedFilters.organization_by.id
            ? payload.selectedFilters.organization_by.id
            : "";
        // eslint-disable-next-line
        let period_by =
          payload.selectedFilters &&
            payload.selectedFilters.period_by &&
            payload.selectedFilters.period_by.id
            ? payload.selectedFilters.period_by.id
            : "";


        if (remittanceSearchText == "") {
          if (payload.searchText != "") {
            remittanceSearchText = payload.searchText;
          }
        }

        if (remittanceSearchText == undefined) {
          remittanceSearchText = "";
        }

        let recordRemittanceListReturned = []
        recordRemittanceListReturned.data = [];
        recordRemittanceListReturned.data.items = [];

        let item1 = [];
        item1.submittedDate = "2020/07/12 2:22 pm";
        item1.submittedBy = "M. Scott";
        item1.remittancesYr = "2021";
        item1.remittancesId = "342";
        item1.invoices = "4";
        item1.status = "Pending";
        item1.amount = "$93.80";
        recordRemittanceListReturned.data.items.push(item1);

        let item2 = [];
        item2.submittedDate = "2020/05/11 10:17 am";
        item2.submittedBy = "A. Smith";
        item2.remittancesYr = "2021";
        item2.remittancesId = "340";
        item2.invoices = "10";
        item2.status = "Accepted";
        item2.amount = "$234.50";
        recordRemittanceListReturned.data.items.push(item2);


        //const recordRemittanceListReturned = await axios.get("vocabularies?trashed=false&search_text=" + remittanceSearchText + "&page_number=" + payload.pageNumber, getActivityHeadersUpdated(payload));

        return {
          recordList: recordRemittanceListReturned,
          total_item_count: recordRemittanceListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.Vocabularies:

        let vocabularySearchText =
          payload.selectedFilters &&
            payload.selectedFilters.vocabularySearchText &&
            payload.selectedFilters.vocabularySearchText.text
            ? payload.selectedFilters.vocabularySearchText.text
            : "";

        if (vocabularySearchText == "") {
          if (payload.searchText != "") {
            vocabularySearchText = payload.searchText;
          }
        }

        if (vocabularySearchText == undefined) {
          vocabularySearchText = "";
        }


        if (payload && payload.pageSize) {
          pageSize = payload.pageSize;
        } else {
          pageSize = 20;
        }

        const recordVocabularyListReturned = await axios.get("vocabularies?trashed=false&search_text=" + vocabularySearchText + "&page_number=" + payload.pageNumber + "&page_size=" + pageSize, getActivityHeadersUpdated(payload));

        return {
          recordList: recordVocabularyListReturned,
          total_item_count: recordVocabularyListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.NodeEdge:
        {
          let recordEdgeListReturned = [];

          const relationOfNodeId =
            payload.selectedFilters &&
              payload.selectedFilters.relationOfNodeId &&
              payload.selectedFilters.relationOfNodeId
              ? payload.selectedFilters.relationOfNodeId
              : "";

          const relationTypeNodeId =
            payload.selectedFilters &&
              payload.selectedFilters.relationTypeNodeId &&
              payload.selectedFilters.relationTypeNodeId
              ? payload.selectedFilters.relationTypeNodeId
              : "";

          const participantSearchText =
            payload.selectedFilters &&
              payload.selectedFilters.participantSearchText &&
              payload.selectedFilters.participantSearchText.text
              ? payload.selectedFilters.participantSearchText.text
              : "";

          const record_state =
            payload.selectedFilters &&
              payload.selectedFilters.record_state &&
              payload.selectedFilters.record_state.id
              ? payload.selectedFilters.record_state.id
              : "";

          recordEdgeListReturned = await axios.get("node_edges?relation_type_node_id=" + relationTypeNodeId +
            "&relation_of_nodeId=" + relationOfNodeId +
            "&search_text=" + participantSearchText +
            "&record_state=" + record_state +
            "&trashed=false" +
            "&pageSize=" + pageSize + "&pageNumber=" + payload.pageNumber);

          return {
            recordList: recordEdgeListReturned,
            total_item_count: recordEdgeListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        }
      case EnumRecordTypes.Period:
        {
          const collectionSearchText =
            payload.selectedFilters &&
              payload.selectedFilters.collectionSearchText &&
              payload.selectedFilters.collectionSearchText.text
              ? payload.selectedFilters.collectionSearchText.text
              : "";
          // eslint-disable-next-line
          const record_state =
            payload.selectedFilters &&
              payload.selectedFilters.record_state &&
              payload.selectedFilters.record_state.id
              ? payload.selectedFilters.record_state.id
              : "";

          let parentRecordId = payload.parentRecordId;

          if (parentRecordId == undefined) {
            parentRecordId = '';
          }

          const recordNodeListReturned = await axios.get(
            `${"Nodes" + "?search_text="
            }${collectionSearchText}&primary_collection_id=` +
            parentRecordId +
            `&page_number=${payload.pageNumber}` +
            `&record_type=${7210}`
          );

          return {
            recordList: recordNodeListReturned,
            total_item_count: recordNodeListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        }
      case EnumRecordTypes.CollectionItem:

        const record_state =
          payload.selectedFilters &&
            payload.selectedFilters.record_state &&
            payload.selectedFilters.record_state.id
            ? payload.selectedFilters.record_state.id
            : "";

        const collectionItemSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.collectionSearchText &&
            payload.selectedFilters.collectionSearchText.text
            ? payload.selectedFilters.collectionSearchText.text
            : "";
        payloadSearchText = payloadSearchText ? payloadSearchText : collectionItemSearchText;

        if (payload.params && payload.params.data_model_contacts_enabled === "true") {
          const recordContactListReturned = await axios.get(
            `${"Contacts" + "?searchText="
            }${payloadSearchText}&primaryCollectionId=` +
            payload.parentRecordId +
            "&recordState=" + record_state +
            "&sortBy=" + sort_by +
            "&isSortOrderDesc=" + is_sort_order_desc +
            `&pageSize=${pageSize}&pageNumber=${payload.pageNumber}`
          );
          return {
            recordList: recordContactListReturned,
            total_item_count: recordContactListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        } else {
          const recordNodeListReturned = await axios.get(
            "collectionitems?search_text=" +
            payloadSearchText +
            "&recordType=" + EnumRecordTypes.CollectionItem +
            "&sort_by=" + sort_by +
            "&is_sort_order_desc=" + is_sort_order_desc +
            (payload.parentRecordId ? ("&parent_collectionItem_id=" + payload.parentRecordId) : "") +
            "&record_state=" + record_state
          );

          return {
            recordList: recordNodeListReturned,
            total_item_count: recordNodeListReturned.data.totalItemCount,
            message: null,
            responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
          };
        }
      case EnumRecordTypes.Activity:
        return getActivityListing(payload);
      case EnumRecordTypes.Processes:
        const processSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.processSearchText &&
            payload.selectedFilters.processSearchText.text
            ? payload.selectedFilters.processSearchText.text
            : "";

        const process_code =
          payload.selectedFilters &&
            payload.selectedFilters.process_code &&
            payload.selectedFilters.process_code.text
            ? payload.selectedFilters.process_code.text
            : "";
        pageSize = payload.pageSize ? payload.pageSize : pageSize
        const recordProcessListReturned = await axios.get(
          "processes/?search_text=" +
          processSearchText +
          "&pageNumber=" +
          payload.pageNumber +
          "&pageSize=" +
          pageSize +
          "&process_code=" +
          process_code
          , getActivityHeadersUpdated(payload));

        return {
          recordList: recordProcessListReturned.data,
          total_item_count: recordProcessListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      case EnumRecordTypes.APP:
        const appSearchText =
          payload.selectedFilters &&
            payload.selectedFilters.appSearchText &&
            payload.selectedFilters.settingSearchText.text
            ? payload.selectedFilters.appSearchText.text
            : "";

        const recordAppListReturned = await axios.get(
          `${"settings" + "?trashed=false" + "&search_text="
          }${appSearchText}&pageSize=${pageSize}&pageNumber=${payload.pageNumber}&sortBy=${sort_by}`
        );

        return {
          recordList: recordAppListReturned.data,
          total_item_count: recordAppListReturned.data.totalItemCount,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
      default:
        return {
          recordList: null,
          recordGAList: null,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
    }
  } catch (error) {
    console.log(error);
    return {
      recordList: [],
      message: `Failed to get records. ${error}`,
    };
  }
};

const getGARecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  const receiveDate = new Date().getTime();
  const pageSize = 100;
  try {
    let recordGAListReturned = null;

    if (
      localStorage["recordGAListReturned"] == null ||
      localStorage["recordGAListReturned"] == ""
    ) {
      const recordGAListReturned = await axios.get(
        `${"settings" + "?trashed=false" + "&search_text="
        }${+"&pageSize="}${pageSize}&pageNumber=${payload.pageNumber}`
      );

      localStorage["recordGAListReturned"] =
        JSON.stringify(recordGAListReturned);

      return {
        recordGAList: recordGAListReturned.data,
        total_item_count: recordGAListReturned.data.totalItemCount,
        message: null,
        responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
      };

    } else {
      recordGAListReturned = JSON.parse(localStorage["recordGAListReturned"]);

      return {
        recordGAList: recordGAListReturned.data,
        total_item_count: recordGAListReturned.data.totalItemCount,
        message: null,
        responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
      };
    }

  } catch (error) {
    alert(error);
    return {
      recordList: [],
      recordGAList: [],
      message: `Failed to get records. ${error}`,
    };
  }
};

function* getGARecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getGARecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordGAListParam = {
        gaRecords: recordListReturned.recordGAList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.totalItemCount,
          totalPages: Math.ceil(recordListReturned.totalItemCount / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getGARecordsSuccess(recordGAListParam));
    } else {
      yield put(getGARecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getGARecordsError(error));
  }
}

function* getRecordList({ payload }) {

  if (payload.isSagaExecuted) {
    yield put(getRecordsError("saga called"));
  }
  else {
    if (!payload.isSagaExecuted) {
      payload.isSagaExecuted = true;
    }

    try {
      let pageSize = 20;
      if (payload.params && payload.params.recordType === "Invoices") {
        pageSize = 5;
      }
      const recordListReturned = yield call(getRecordListAsync, payload);
      if (!recordListReturned.message) {
        const recordListParam = {
          records: recordListReturned.recordList,
          pagination: {
            pageNumber: payload.pageNumber,
            pageSize,
            startIndex: (payload.pageNumber - 1) * pageSize + 1,
            totalItemCount: recordListReturned.total_item_count,
            totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
          },
          responseTime: recordListReturned.responseTime,
        };
        if (payload.searchInputName) {
          recordListParam.searchInputName = recordListReturned.recordList;
        }
        yield put(getRecordsSuccess(recordListParam));
      } else {
        yield put(getRecordsError(recordListReturned.message));
      }
    } catch (error) {
      yield put(getRecordsError(error));
    }
  }
}

function* getChildRecordList({ payload }) {
  try {
    let pageSize = -1;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize: -1,
          startIndex: 0,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getChildRecordsSuccess(recordListParam));
    } else {
      yield put(getChildRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getChildRecordsError(error));
  }
}

function* getDropdownSearchList({ payload }) {
  try {
    let recordListReturned = null;

    let storageRecordListReturned = localStorage.getItem("recordListReturned");

    if (payload.param == "code" || payload.param == "processCode") {
      if (storageRecordListReturned == null || storageRecordListReturned == "") {
        recordListReturned = yield call(getRecordListAsync, {
          recordType: payload.searchRecordType,
          searchText: payload.searchText,
          pageNumber: 1,
          param: payload.param,
          parentRecordId: payload.parentRecordId,
          isPersonOnly: true,
          activityInfo: payload.activityInfo,
          pageSize: -1
        });

        localStorage.setItem("recordListReturned", JSON.stringify(recordListReturned));

        setTimeout(() => {
          localStorage.setItem("recordListReturned", "");
        }, 3600000)
      }
      else {
        recordListReturned = JSON.parse(localStorage.getItem("recordListReturned"));
      }
    }
    else {
      recordListReturned = yield call(getRecordListAsync, {
        recordType: payload.searchRecordType,
        searchText: payload.searchText,
        pageNumber: 1,
        param: payload.param,
        parentRecordId: payload.parentRecordId,
        isPersonOnly: true,
        activityInfo: payload.activityInfo,
        pageSize: -1
      });

    }

    if (!recordListReturned.message) {
      let recordList = [];
      let searchResult = {};



      if (payload.param == Params.recordstate) {
        for (const key in EnumRecordStates) {
          let inKey = key;
          let value = parseInt(EnumRecordStates[inKey]);
          recordList.push({
            text: inKey,
            id: value,
          });
        }
      }

      switch (payload.searchRecordType) {

        case EnumRecordTypes.Activity:
          if (payload.param == Params.recordtype) {
            for (const key in EnumRecordTypes) {
              let inKey = key;
              let value = parseInt(EnumRecordTypes[inKey]);
              recordList.push({
                text: inKey,
                id: value,
              });
            }
          } else {
            recordListReturned.recordList.items.forEach((activity) => {
              recordList.push({
                text: activity.activityDescription,
                id: activity.activityId,
              });
            });
          }
          break;
        case EnumRecordTypes.CollectionItem:
          recordListReturned.recordList.data.items.forEach((collectionItem) => {
            recordList.push({
              text: collectionItem.name,
              id: collectionItem.nodeId,
            });
          });
          break;
        case EnumRecordTypes.Collection:
          recordListReturned.recordList.data.items.forEach((collection) => {
            recordList.push({
              text: collection.name,
              id: collection.collectionId,
            });
          });
          break;
        case EnumRecordTypes.PROJECTS:
          recordListReturned.recordList.forEach((collection) => {
            recordList.push({
              text: collection.name,
              id: collection.collectionId,
            });
          });
          break;
        case EnumRecordTypes.Task:

          if (payload.param == Params.incomplete) {
            recordListReturned.recordList.forEach((task) => {
              if (task.post_response.completed == false) {
                recordList.push({
                  text: task.post_response.title,
                  id: task.post_response.postId,
                });
              }
            });
          } else if (payload.param == Params.priority) {
            recordList.push({
              text: "High",
              id: "1",
            });
            recordList.push({
              text: "Normal",
              id: "2",
            });
          } else if (payload.param == Params.status) {
            recordList.push({
              text: "New",
              id: "1",
            });
            recordList.push({
              text: "Old",
              id: "2",
            });
          } else {
            recordListReturned.recordList.forEach((task) => {
              recordList.push({
                text: task.post_response.title,
                id: task.post_response.postId,
              });
            });
          }
          break;
        case EnumRecordTypes.Period:
          {
            recordListReturned.recordList.data.items.forEach((node) => {
              recordList.push({
                text: node.name,
                id: node.nodeId,
              });
            });
            break;
          }
        case EnumRecordTypes.OrderStatus:
          {
            recordListReturned.recordList.forEach((status) => {
              recordList.push({
                text: status.text,
                id: status.id,
              });
            });
            break;
          }
        case EnumRecordTypes.TaskList:
          recordListReturned.recordList.forEach((task) => {
            recordList.push({
              text: task.post_response.title,
              id: task.post_response.postId,
            });
          });
          break;
        case EnumRecordTypes.Processes:


          if (payload.param == Params.processtype) {
            recordListReturned.recordList.items.forEach((process) => {
              recordList.push({
                text:
                  payload.param == Params.processtype
                    ? process.name
                    : process.summary,
                id: process.processId,
              });
            });
          }
          else if (payload.param == Params.processCode) {

            let filterRecord = recordListReturned.recordList.items.map((enumProcessCode) => enumProcessCode.enumProcessCode)
            let filtered = recordListReturned.recordList.items.filter(({ enumProcessCode }, index) => !filterRecord.includes(enumProcessCode, index + 1))

            filtered = filtered.sort((a, b) => a.enumProcessCode.localeCompare(b.enumProcessCode));

            filtered.forEach((process) => {
              recordList.push({
                text: process.enumProcessCode,
                id: process.processId,
              });
            });
            localStorage.setItem("enumProcessCode", payload.searchText)
          }
          else if (payload.param == Params.code) {

            let enumProcessCode = localStorage.getItem("enumProcessCode")
            let processId = localStorage.getItem("processId")
            let filtered = recordListReturned.recordList.items.sort((a, b) => a.processCode.localeCompare(b.processCode));

            if (enumProcessCode == '') {
              filtered.forEach((process) => {
                recordList.push({
                  text: process.processCode,
                  id: process.processId,
                });
              });
            }
            if (processId != '') {
              filtered.forEach((process) => {
                if (process.parentProcessId == processId || process.processId == processId)
                  recordList.push({
                    text: process.processCode,
                    id: process.processId,
                  });
              });
            }
            else {
              filtered.forEach((process) => {
                if (process.enumProcessCode == enumProcessCode)
                  recordList.push({
                    text: process.processCode,
                    id: process.processId,
                  });
              });
            }

          }
          else {
            recordListReturned.recordList.items.forEach((process) => {
              recordList.push({
                text: process.name,
                id: process.processId,
              });
            });
          }
          break;
        case EnumRecordTypes.SaaS:
          recordListReturned.recordList.items.forEach((tenant) => {
            recordList.push({
              text: tenant.tenant_name,
              id: tenant.tenantId,
            });
          });
          break;
        case EnumRecordTypes.Person:
        case EnumRecordTypes.Organization:
          if (payload.param == Params.username) {
            recordListReturned.recordList.forEach((currentcontact) => {
              recordList.push({
                text: currentcontact.userName,
                id: currentcontact.contactId,
              });
            });
          }
          else {
            recordListReturned.recordList.forEach((currentcontact) => {
              recordList.push({
                text: currentcontact.displayName,
                id: currentcontact.contactId,
              });
            });
          }


          break;
        case EnumRecordTypes.Address:
          recordListReturned.recordList.forEach((currentLocation) => {
            recordList.push({
              text: currentLocation.Address.Text,
              id: currentLocation.Address.id,
            });
          });
          break;
        case EnumRecordTypes.ContactTypes:
          recordListReturned.recordList.forEach((node) => {
            recordList.push({
              id: node.nodeId,
              text: node.name,
            });
          });
          break;

        case EnumRecordTypes.Settings:
          recordListReturned.recordList.forEach((currentInv) => {
            recordList.push({
              text: currentInv.Setting.Name,
              id: currentInv.Setting.SettingId,
            });
          });
          break;
        case EnumRecordTypes.Vocabularies:
          recordListReturned.recordList.data.items.forEach((vocabulary) => {
            recordList.push({
              text: vocabulary.name,
              id: vocabulary.vocabularyId,
            });
          });
          break;
        case EnumRecordTypes.Invoices:
          recordListReturned.recordList.forEach((invoice) => {
            recordList.push({
              text: invoice.invoiceId.toString(),
              id: invoice.invoiceId,
            });
          });
          break;
        case EnumRecordTypes.Orders:
          recordListReturned.recordList.data.items.forEach((order) => {
            recordList.push({
              text: order.orderId,
              id: order.orderId,
            });
          });
          break;
        case EnumRecordTypes.OrderTag:
          recordListReturned.recordList.data.items.forEach((order) => {
            recordList.push({
              text: order.tag,
              id: order.orderId,
            });
          });
          break;
        case EnumRecordTypes.OrderPeriod:
          recordListReturned.recordList.data.items.forEach((order) => {
            recordList.push({
              text: order.period,
              id: order.orderId,
            });
          });
          break;
        case EnumRecordTypes.OrderConfirmation:
          recordListReturned.recordList.data.items.forEach((order) => {
            recordList.push({
              text: order.Confirmation,
              id: order.orderId,
            });
          });
          break;
        default:
          break;
      }
      if (payload.searchInputName) {
        searchResult[payload.searchInputName] = recordList;
      }
      yield put(getSearchListSuccess(payload.searchInputName ? searchResult : recordList));
    } else {
      yield put(getSearchListSuccess([]));
    }
  } catch (error) {
    yield put(getSearchListSuccess([]));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetRecords),
    fork(watchGetChildRecords),
    fork(watchGetGARecords),
    fork(watchGetDropdownSearchList),
  ]);
}
